var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-layout"},[_c('div',{staticClass:"layout-header"},[_c('Header')],1),_c('div',{staticClass:"layout-content"},[_vm._t("default"),_c('div',{staticClass:"layout-footer"},[_c('LayoutFooter')],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }